import { Button, IconButton } from '@mui/material';
import { fetchArray } from 'entity';
import React, { useCallback, useState } from 'react'
import EntitySearchDialog from './form/EntitySearch/EntitySearchDialog';
import SearchIcon from "@mui/icons-material/Search";
export default function ButtonSelectEntity({ EntityClass, button, extraQuery, onSelect, label, hideFilterColumns, defaultFilters }) {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);

    // const [searchDialog, setSearchDialog] = useState();

    const loadOptions = useCallback(async () => {

        if (options.length === 0) {
            let query = await EntityClass.query();

            if (extraQuery) {
                query = extraQuery(query);
            }

            let result = await fetchArray(query.get());
            setOptions(result);
        }
    }, [EntityClass, extraQuery, options.length]);

    function openSearchDialog() {
        loadOptions();
        // searchDialog.setOpen(true);
        setOpen(true)
    }
    return (
        <>
            {button ? <Button onClick={openSearchDialog}>
                {button}
            </Button> : <IconButton onClick={openSearchDialog} sx={{ p: "2px" }}>
                <SearchIcon />
            </IconButton>}
            {open &&
                <EntitySearchDialog
                    open={open}
                    checkboxSelection={false}
                    title={label || "Selecionar"}
                    columns={EntityClass.searchColumns}
                    data={options}
                    hideFilterColumns={hideFilterColumns}
                    defaultFilters={defaultFilters}
                    onClose={(value) => {
                        setOpen(false)
                        console.log('onClose', value)
                        if (value) {
                            onSelect(value)
                        }
                    }}
                />
            }
        </>
    )
}
